import { observable } from 'mobx';

let obx = observable({
  userData: null
});

export default obx;